{
  "editMode_deleteButtonAriaLabel": "Delete"
}
